// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://rvmfsprvpagfmpdyliwp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ2bWZzcHJ2cGFnZm1wZHlsaXdwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU3Nzc2MDUsImV4cCI6MjA2MTM1MzYwNX0.hxORtykICr2RPRB7eOrYHAOsZ5cWvVSD0-tHjgib19Q";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);